<!-- auth-page wrapper -->
<div
  class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100"
>
  
  <!-- auth-page content -->
  <div class="auth-page-content overflow-hidden pt-lg-5">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="card overflow-hidden">
            <div class="row g-0">
              <div class="col-lg-6">
                <div class="p-lg-5 p-4 auth-one-bg h-100"></div>
              </div>
              <!-- end col -->

              <div class="col-lg-6">
                <div class="p-lg-5 p-4">
                  <div>
                    <h5 class="text-primary">Welcome Back !</h5>
                    <p class="text-muted">Sign as a super admin in to continue</p>
                  </div>

                  <div class="mt-4">
                    <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
                      <div class="mb-3">
                        <label for="username" class="form-label"
                          >Username</label
                        >
                        <input
                          type="text"
                          class="form-control"
                          id="username"
                          placeholder="Enter username"
                          formControlName="identifier"
                          value="admin@admin.com"
                          [ngClass]="{
                            'is-invalid': submitted && f['identifier'].errors
                          }"
                        />
                        <div
                          *ngIf="submitted && f['identifier'].errors"
                          class="invalid-feedback"
                          align="left"
                        >
                          <div *ngIf="f['identifier'].errors['required']">
                            Username is required
                          </div>
                        </div>
                      </div>

                      <div class="mb-3">
                        <!-- <div class="float-end">
                          <a
                            routerLink="/auth/pass-reset/cover"
                            class="text-muted"
                            >Forgot password?</a
                          >
                        </div> -->
                        <label class="form-label" for="password-input"
                          >Password</label
                        >
                        <div
                          class="position-relative auth-pass-inputgroup mb-3"
                        >
                          <input
                            [type]="fieldTextType ? 'text' : 'password'"
                            class="form-control pe-5 password-input"
                            placeholder="Enter password"
                            id="password-input"
                            formControlName="password"
                            value="alex12345"
                            [ngClass]="{
                              'is-invalid': submitted && f['password'].errors
                            }"
                          />
                          <button
                            class="btn btn-link position-absolute end-0 top-0 text-decoration-none text-muted password-addon"
                            type="button"
                            id="password-addon"
                          >
                            <i
                              class="mdi align-middle"
                              [ngClass]="{
                                'mdi-eye-off-outline': !fieldTextType,
                                'mdi-eye-outline': fieldTextType
                              }"
                              (click)="toggleFieldTextType()"
                            ></i>
                          </button>
                          <div
                            *ngIf="submitted && f['password'].errors"
                            class="invalid-feedback"
                          >
                            <div *ngIf="f['password'].errors['required']">
                              Password is required
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- <div class="form-check">
                        <input
                          class="form-check-input"
                          type="checkbox"
                          value=""
                          id="auth-remember-check"
                        />
                        <label
                          class="form-check-label"
                          for="auth-remember-check"
                          >Remember me</label
                        >
                      </div> -->

                      <div class="mt-4">
                        <!-- login.component.html -->
                        <button
                          class="btn btn-success w-100"
                          type="submit"
                          [disabled]="loading"
                        >
                          <!-- Normal State -->
                          <span *ngIf="!loading">Sign In</span>

                          <!-- Loading State -->
                          <span *ngIf="loading">
                            <span
                              class="spinner-border spinner-border-sm align-middle me-2"
                            ></span>
                            Signing in...
                          </span>
                        </button>
                      </div>

                      <div class="mt-4 text-center">
                        <div class="signin-other-title">
                          <h5 class="fs-13 mb-4 title">Visit Us:</h5>
                        </div>
                        <div class="mb-4">
                          <a
                            href="https://saslab.in/"
                            target="_blank"
                            class="d-block"
                          >
                            <img
                              src="assets/images/logo-transparent.png"
                              alt=""
                              height="58"
                            />
                          </a>
                          <small
                            >&copy; {{ year }} Saslab. All rights
                            reserved.</small
                          >
                        </div>
                      </div>
                    </form>
                  </div>

                  <div class="mt-5 text-center">
                    <small
                      >Developed and Maintained by
                      <a
                        href="https://saslab.in/"
                        target="_blank"
                        title="Clcik on to visit website"
                        >SasLab</a
                      ></small
                    >
                  </div>
                </div>
              </div>
              <!-- end col -->
            </div>
            <!-- end row -->
          </div>
          <!-- end card -->
        </div>
        <!-- end col -->
      </div>
      <!-- end row -->
    </div>
    <!-- end container -->
  </div>
  <!-- end auth page content -->

  <!-- footer -->
  <footer class="footer">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="text-center">
            <p class="mb-0">version: {{ version }}</p>
          </div>
        </div>
      </div>
    </div>
  </footer>
  <!-- end Footer -->
</div>
<!-- end auth-page-wrapper -->
